import React from 'react';
import { Link, useNavigate, Outlet } from 'react-router-dom';
import { clearAdminToken } from '../../utils/adminRequest';

function AdminLayout() {
  const navigate = useNavigate();

  const logout = () => {
    clearAdminToken();
    navigate('/admin');
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <header style={{
        background: '#1a1a2e', color: '#fff', padding: '12px 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: 12
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
          <Link to="/admin/activities" style={{ color: '#fff', textDecoration: 'none', fontWeight: 600 }}>
            活动管理
          </Link>
          <Link to="/admin/registrations" style={{ color: '#fff', textDecoration: 'none', fontWeight: 600 }}>
            报名管理
          </Link>
          <Link to="/admin/members" style={{ color: '#fff', textDecoration: 'none', fontWeight: 600 }}>
            会员管理
          </Link>
          <Link to="/admin/membership" style={{ color: '#fff', textDecoration: 'none', fontWeight: 600 }}>
            会员配置
          </Link>
        </div>
        <button
          onClick={logout}
          style={{
            padding: '8px 16px', background: 'rgba(255,255,255,0.2)',
            border: 'none', borderRadius: 6, color: '#fff', cursor: 'pointer', fontSize: 14
          }}
        >
          退出
        </button>
      </header>
      <main style={{ padding: 20, maxWidth: 1200, margin: '0 auto' }}>
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
